import { FC } from 'react';
import { Modal, Text } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

export interface RiderServiceRequestModalProps {
  isOpen: boolean;
  handleResubmit: () => void;
  handleClose: () => void;
  listOfServices: string[];
}

export const RiderServiceRequestModal: FC<RiderServiceRequestModalProps> = ({
  isOpen,
  handleClose,
  handleResubmit,
  listOfServices,
}) => {
  const formattedServicesList = (() => {
    if (listOfServices.length === 1) {
      return listOfServices[0];
    }

    if (listOfServices.length === 2) {
      return `${listOfServices[0]} and ${listOfServices[1]}`;
    }

    if (listOfServices.length > 2) {
      return `${listOfServices.slice(0, -1).join(', ')}, and ${listOfServices[listOfServices.length - 1]}`;
    }

    return '';
  })();

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Modal.Title>Ride Request</Modal.Title>
      <Modal.Content>
        <Text variant="body1" fontWeight={300} mb={4}>
          This ride or Ride Series requires the following rider services: {formattedServicesList}. The ride fare will
          include an additional rider service fee.
        </Text>
        <Text variant="body1" fontWeight={300}>
          To ensure we are able to fulfill the required rider services, this ride will be in{' '}
          <span style={{ fontWeight: 'bold' }}>Requested</span> status while our Operations team reviews the request.
          You will receive a response approving or denying the request within one business day.
        </Text>
      </Modal.Content>
      <Modal.Actions>
        <Button color="tertiary" onClick={handleClose}>
          Back
        </Button>
        <Button color="primary" variant="contained" onClick={handleResubmit}>
          Send Request
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
